import React, { useState, useLayoutEffect, useContext } from 'react';

import * as S from './styles';
import SimpleInput from 'components/SimpleInput';
import SelectInput from 'components/SelectInput';
import {
	optionsTypeTitleRedirect,
	optionsWeightFontText
} from 'utils/optionsInputs';
import { SelectInputItemProps } from 'types/SelectInputItemProps';
import Check from 'components/Buttons/Check';
import { formatDateToISO, formatToDateCustom } from 'utils/functions';
import { DataFormProps } from 'components/FormDynamicPageSelected/Forms/InputsTitleWithRedirect/index';
import DynamicPageContext from 'context/DynamicPage';
import InputColor from 'components/InputColor';

interface DataFormTitleWithRedirectProps {
	isShow: boolean;
	dataForm: DataFormProps;
	setDataForm: React.Dispatch<React.SetStateAction<DataFormProps>>;
}

export default function DataFormTitleWithRedirect({
	isShow,
	dataForm,
	setDataForm
}: DataFormTitleWithRedirectProps) {
	const { moduleInSavingMode, moduleOnPhoneToEdit } =
		useContext(DynamicPageContext);

	const [isShowDateInputs, setIsShowDateInputs] = useState(false);

	function findeOptionOnListByNumber(
		value: string,
		list: SelectInputItemProps[]
	) {
		const itemsList = list.filter((item) => item.id === value);
		if (itemsList.length > 0) {
			return itemsList[0];
		}

		return '';
	}

	//reseta os dados de agendamento os inputs não estejam visiaveis
	useLayoutEffect(() => {
		if (!isShowDateInputs) {
			setDataForm((obj) => ({
				...obj,
				countdown: false,
				schedule_end: '',
				schedule_start: ''
			}));
		}
	}, [isShowDateInputs]);

	//se estiver em edição aqui pega os dados do item editado
	useLayoutEffect(() => {
		if (moduleOnPhoneToEdit !== null && moduleInSavingMode === null) {
			setTimeout(() => {
				setDataForm((obj) => ({ ...obj, ...moduleOnPhoneToEdit.data }));
			}, 100);

			if (moduleOnPhoneToEdit?.data?.schedule_start !== '') {
				setIsShowDateInputs(true);
			}
		}
	}, []);

	return (
		<S.container $isShow={isShow}>
			<S.fourInputs>
				<SimpleInput
					label="Título *"
					initialValue={dataForm.name}
					getValue={(value: string) => {
						setDataForm((obj) => ({ ...obj, name: value }));
					}}
				/>

				<SelectInput
					list={optionsTypeTitleRedirect}
					getValue={(value: SelectInputItemProps | '') => {
						setDataForm((obj) => ({
							...obj,
							type: value === '' ? value : (value?.id as string)
						}));
					}}
					initialValue={
						dataForm.type === ''
							? optionsTypeTitleRedirect[0]
							: findeOptionOnListByNumber(
									dataForm.type || '',
									optionsTypeTitleRedirect
								)
					}
					label="Tipo"
				/>

				<SimpleInput
					paddingInLineEnd
					typeInput="number"
					label="Altura"
					initialValue={dataForm.height}
					getValue={(value: string) => {
						setDataForm((obj) => ({ ...obj, height: value }));
					}}
				/>

				<SelectInput
					list={optionsWeightFontText}
					getValue={(value: SelectInputItemProps | '') => {
						setDataForm((obj) => ({
							...obj,
							weight: value === '' ? value : (value?.id as string)
						}));
					}}
					initialValue={
						dataForm.type === ''
							? ''
							: findeOptionOnListByNumber(
									dataForm.weight || '',
									optionsWeightFontText
								)
					}
					label="Peso da fonte"
				/>

				<SimpleInput
					paddingInLineEnd
					typeInput="number"
					label="Padding esquerdo"
					initialValue={dataForm.padding_left}
					getValue={(value: string) => {
						setDataForm((obj) => ({ ...obj, padding_left: parseInt(value) }));
					}}
				/>

				<SimpleInput
					paddingInLineEnd
					typeInput="number"
					label="Padding direito"
					initialValue={dataForm.padding_right}
					getValue={(value: string) => {
						setDataForm((obj) => ({ ...obj, padding_right: parseInt(value) }));
					}}
				/>

				<SimpleInput
					paddingInLineEnd
					typeInput="number"
					label="Padding superior"
					initialValue={dataForm.padding_top}
					getValue={(value: string) => {
						setDataForm((obj) => ({ ...obj, padding_top: parseInt(value) }));
					}}
				/>

				<SimpleInput
					paddingInLineEnd
					typeInput="number"
					label="Padding inferior"
					initialValue={dataForm.padding_bottom}
					getValue={(value: string) => {
						setDataForm((obj) => ({ ...obj, padding_bottom: parseInt(value) }));
					}}
				/>

				<SimpleInput
					paddingInLineEnd
					typeInput="number"
					label="Borda superior esquerda"
					initialValue={dataForm.border_left}
					getValue={(value: string) => {
						setDataForm((obj) => ({ ...obj, border_left: parseInt(value) }));
					}}
				/>

				<SimpleInput
					paddingInLineEnd
					typeInput="number"
					label="Borda superior direita"
					initialValue={dataForm.border_right}
					getValue={(value: string) => {
						setDataForm((obj) => ({ ...obj, border_right: parseInt(value) }));
					}}
				/>

				<SimpleInput
					paddingInLineEnd
					typeInput="number"
					label="Borda direta inferior"
					initialValue={dataForm.border_top}
					getValue={(value: string) => {
						setDataForm((obj) => ({ ...obj, border_top: parseInt(value) }));
					}}
				/>

				<SimpleInput
					paddingInLineEnd
					typeInput="number"
					label="Borda esquerda inferior"
					initialValue={dataForm.border_bottom}
					getValue={(value: string) => {
						setDataForm((obj) => ({ ...obj, border_bottom: parseInt(value) }));
					}}
				/>
				<InputColor
					rgbOrExadecimal={false}
					label="Cor do texto"
					value={dataForm.color}
					setValue={(value: string) => {
						setDataForm((obj) => ({ ...obj, color: value }));
					}}
				/>
			</S.fourInputs>

			<div style={{ display: 'none' }}>
				<Check
					text="Programação"
					isChecked={isShowDateInputs}
					setIsChecked={() => {
						setIsShowDateInputs((obj) => !obj);
					}}
				/>

				{isShowDateInputs && (
					<>
						<S.inputsDate>
							<SimpleInput
								typeInput="datetime-local"
								label="Ínicio"
								initialValue={
									dataForm.schedule_start === ''
										? ''
										: formatToDateCustom(dataForm.schedule_start)
								}
								getValue={(value: string) => {
									setDataForm((obj) => ({
										...obj,
										schedule_start: formatDateToISO(value)
									}));
								}}
								paddingInLineEnd
							/>

							<SimpleInput
								typeInput="datetime-local"
								label="Fim"
								initialValue={
									dataForm.schedule_end === ''
										? ''
										: formatToDateCustom(dataForm.schedule_end)
								}
								getValue={(value: string) => {
									setDataForm((obj) => ({
										...obj,
										schedule_end: formatDateToISO(value)
									}));
								}}
								paddingInLineEnd
							/>
						</S.inputsDate>

						<Check
							text="Contagem regressiva"
							isChecked={dataForm.countdown}
							setIsChecked={() => {
								setDataForm((obj) => ({
									...obj,
									countdown: !obj.countdown
								}));
							}}
						/>
					</>
				)}
			</div>
		</S.container>
	);
}
